import React, {useCallback, useContext, useEffect} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {useParams} from "react-router-dom";
import HideAppBar from "../../../widgets/header/HideAppBar";
import {Card, CardContent, Container} from "@mui/material";
import Grid from "@mui/material/Grid";
import DiarioPaziente from "../../../widgets/diary/DiarioPaziente";
import clsx from "clsx";
import PazienteDrawer from "../drawer/PazienteDrawer";
import AnagraficaDetailSection from "./section/AnagraficaDetailSection";
import RelazioniSection from "./section/RelazioniSection";
import TicketSection from "./section/TicketSection";
import PrenotaTamponeCard from "../../ticket/details/PrenotaTamponeCard";
import NoteSection from "./section/NoteSection";
import IntervisteSection from "./section/IntervisteSection";
import QuaranteneSection from "./section/QuaranteneSection";
import DocumentiSection from "./section/DocumentiSection";
import CreaTamponeCard from "./section/CreaTamponeCard";
import CreaVaccinoCard from "./section/CreaVaccinoCard";
import {useSessionStorage} from "../../../../utils/hooks/SessionStorageHook";
import {AnagraficaContext} from "../../../../App";
import {resetGetAnagrafica} from "../../../../services/AnagraficaServices";

const PazienteDetailPage = () => {
	const classes = BaseStyle();
	let {idSoggetto} = useParams();
	const [stato, setStato] = useSessionStorage("statop", "Diario");
	const anagraficaContext = useContext(AnagraficaContext);

	const selectMenuItem = useCallback(item => {
		setStato(item)
	}, [setStato])

	useEffect(() => {
		resetGetAnagrafica(anagraficaContext.dispatch)
	}, [anagraficaContext.dispatch])

	return (
		<React.Fragment>
			<main className={classes.main}>
				<HideAppBar title={"Anagrafica Cod. " + idSoggetto} back={true}/>
				<Container component={"section"} maxWidth={"xl"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardContent style={{flexGrow: 1, display: "flex"}}>

									<PazienteDrawer stato={stato} selectMenuItem={selectMenuItem}/>

									<div className={classes.content800}>
										{
											stato === "Diario" && <DiarioPaziente idSoggetto={idSoggetto}/>
										}
										{
											stato === "Anagrafica" && <AnagraficaDetailSection idSoggetto={idSoggetto}/>
										}
										{
											stato === "Relazioni" && <RelazioniSection idSoggetto={idSoggetto}/>
										}
										{
											stato === "Ticket" && <TicketSection idSoggetto={idSoggetto}/>
										}
										{/*{*/}
										{/*	stato === "Isolamenti" && <QuaranteneSection idSoggetto={idSoggetto}/>*/}
										{/*}*/}
										{/*{*/}
										{/*	stato === "Interviste" && <IntervisteSection idSoggetto={idSoggetto}/>*/}
										{/*}*/}
										{
											stato === "Note" && <NoteSection idSoggetto={idSoggetto}/>
										}
										{/*{*/}
										{/*	stato === "Tampone" && <PrenotaTamponeCard idSoggetto={idSoggetto}/>*/}
										{/*}*/}
										{/*{*/}
										{/*	stato === "Crea tampone" && <CreaTamponeCard idSoggetto={idSoggetto}/>*/}
										{/*}*/}
										{/*{*/}
										{/*	stato === "Crea vaccino" && <CreaVaccinoCard idSoggetto={idSoggetto}/>*/}
										{/*}*/}
										{
											stato === "Documenti" && <DocumentiSection idSoggetto={idSoggetto}/>
										}
									</div>
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</Container>
			</main>
		</React.Fragment>
	);
};

export default React.memo(PazienteDetailPage)
